
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  hasPreview?: boolean | undefined,
  locale: string,
  slug: string
};

/**
 * Export `fetchCollection`.
 */

export async function fetchCollection({ hasPreview, locale, slug }: Query) {
  const endpoint = getApiEndpoint('getCollection', { slug });
  const relatedEndpoint = getApiEndpoint('getCollectionsRelated', { slug });

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      ...hasPreview && { params: { preview: true } }
    });

    const { data: relatedData } = await request.get(relatedEndpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return {
      ...data?.data,
      related: relatedData?.data
    };
  } catch (error) {
    handleRequestError(error);
  }
}
